import { Locales } from '../localization/locales';

export default {
  [Locales.ru]: {
    search: 'Поиск',
    selected: 'Выбрано',
  },
  [Locales.en]: {
    search: 'Search',
    selected: 'Selected',
  }
}
